export const COUNTRY_AUSTRALIA = "Australia";
export const COUNTRY_AUSTRALIA_CODE = "AU";

export const COUNTRY_CANADA = "Canada";
export const COUNTRY_CANADA_CODE = "CA";

export const COUNTRY_FRANCE = "France";
export const COUNTRY_FRANCE_CODE = "FR";

export const COUNTRY_UK = "United Kingdom";
export const COUNTRY_UK_CODE = "GB";

export const COUNTRY_US = "United States";
export const COUNTRY_US_CODE = "US";
